import type { Locale } from './events.js';

/** Übersetzungs-Wörterbuch: pro Sprache ein Schlüssel→Text-Mapping. */
export type Dict = Partial<Record<Locale, Record<string, string>>>;

/**
 * Minimaler Übersetzer: liefert den Text zur Sprache, fällt auf Deutsch zurück,
 * dann auf den Schlüssel selbst. `{name}`-Platzhalter werden ersetzt.
 */
export function translate(dict: Dict, locale: Locale, key: string, params?: Record<string, string | number>): string {
  let s = dict[locale]?.[key] ?? dict.de?.[key] ?? key;
  if (params) for (const k of Object.keys(params)) s = s.split('{' + k + '}').join(String(params[k]));
  return s;
}
